import styled from 'styled-components';

import {
  titleColor,
  buttonBackground,
  informationText
} from '../../styles/colors';

export {
  Label,
  Button,
  CancelButton,
  Input,
  ErrorMessage,
} from '../../elements';

export const Container = styled.div`
  display: block;
  width: 470px;
  max-width: 90%;
  height: 570px;
  background-color: white;

  border-radius: 8px;
  filter: drop-shadow(0px 4px 50px rgba(0, 0, 0, 0.12));
`;

export const InnerContainer = styled.div`
  display: block;

  margin-left: 56px;
  margin-right: 56px;
  margin-top: 24px;
  margin-bottom: 24px;
  max-height: 440px;
  overflow-y: scroll;

  @media (max-width: 480px) {
    margin-left: 5%;
    margin-right: 5%;
  }
`;

export const Title = styled.h1`
  color: ${titleColor};
  font-weight: 500;
  font-size: 1.6rem;
  margin-bottom: 2rem;
`;

export const Instructions = styled.div`
  color: ${informationText};
  margin-bottom: 2rem;
`;

export const ActionLink = styled.a`
  color: ${buttonBackground};
  cursor: pointer;
  text-decoration: none;
`;
